<template>
  <div :class="[`${$style.issue}`]">
    <TopHeader
      headerTitle="发表帖子"
      :isShowMenu="false"
      :customBack="true"
      @back="issueTopicBack"
    ></TopHeader>
    <van-field v-model="topicTitle" placeholder="请输入标题(最多25个字)" maxlength="25" />
    <!-- 2021.11.26 删除了选择游戏圈功能 若要恢复添加代码到下面 @click="showPicker = true" -->
    <van-cell title="游戏圈" :value="selectedGircleName || '请选择游戏圈'" />
    <!-- 游戏圈选择器 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="confirm"
        value-key="name"
      ></van-picker>
    </van-popup>
    <!-- 编辑器 -->
    <div
      ref="editor"
      :class="$style.editor"
      contenteditable="plaintext-only"
      @blur="getTextCursor"
    ></div>
    <!-- 编辑器底部 -->
    <div :class="$style.footer">
      <div :class="$style.operate">
        <EmojiSelector
          v-if="emojiSelectorShow"
          @close="emojiSelectorShow = false"
          @selectEmoji="insertSelectEmoji"
          :class="`${$style.emoji} ${emojiSelectorShow && $style.active}`"
        ></EmojiSelector>
        <!-- 表情 -->
        <img :src="`${$cdnUrl}/logo_1.png`" alt="表情" @click="chooseEmoji" />
        <!-- 图片 -->
        <img :src="`${$cdnUrl}/photo.png`" alt="图片" @click="insertImage" />
      </div>
      <van-button :class="`${$style.submit} hm-small-btn`" type="default" @click="submit"
        >发送</van-button
      >
    </div>
  </div>
</template>

<script>
import TopHeader from './TopHeader';
import EmojiSelector from './EmojiSelector';
import { Button, Field, Cell, Popup, Picker, Dialog, Toast } from 'vant';
import UploadMixin from '@/mixins/uploadImage';
import { getIssueCircleList } from '@/api/gameCircleCenter';
import { addTopic } from '@/api/app';
import { mapState, mapActions } from 'vuex';
import { CDN_URL } from '@/config/index.js';
export default {
  name: '',
  components: {
    TopHeader,
    EmojiSelector,
    VanButton: Button,
    VanField: Field,
    VanPopup: Popup,
    VanPicker: Picker,
    VanCell: Cell,
  },
  mixins: [UploadMixin],
  data() {
    return {
      topicTitle: '',
      showPicker: false,
      selectedCircleId: this.$route.query.circleId || '',
      selectedGircleName: '', // 选中的游戏圈名称
      emojiSelectorShow: false, // 表情选择器是否显示
      TextCursor: '', // 失去焦点时光标所在位置
      editor: '',
      issueCircleList: [],
      columns: [],
      editorContent: '',
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    circleId() {
      return this.$route.query.circleId || '';
    },
  },
  created() {
    this.getIssueCircleList();
  },
  destroyed() {
    this.moveEventListener();
  },
  methods: {
    ...mapActions('account', {
      getUserInfo: 'getUserInfo',
    }),
    // 返回
    issueTopicBack() {
      this.$emit('closeIssueTopicField');
    },
    // 发布帖子时候可选游戏圈列表
    async getIssueCircleList() {
      const r = await getIssueCircleList();
      this.issueCircleList = [...r.data];
      try {
        this.selectedGircleName = this.circleId
          ? this.issueCircleList.find((item) => item.id == this.circleId).name
          : '';
      } catch (error) {
        console.log(error);
      }
      if (!r.data.length) return;
      this.columns = r.data.map((item) => {
        return item.name;
      });
    },
    // 选择游戏圈
    confirm(e) {
      this.selectedGircleName = e;
      try {
        this.selectedCircleId = this.issueCircleList.find((item) => item.name === e).id;
      } catch (error) {
        console.log(error);
      }
      this.showPicker = false;
    },
    // 获取文本光标
    getTextCursor() {
      this.textCursor = window.getSelection().getRangeAt(0);
    },
    // 点击表情图标打开表情选择器
    chooseEmoji() {
      this.emojiSelectorShow = !this.emojiSelectorShow;
      this.$refs.editor.blur();
    },
    // 将选择的表情插入到编辑器中
    insertSelectEmoji(emojiName) {
      let div = document.createElement('div');
      div.innerHTML = `<img src=${CDN_URL}/emoji/${emojiName}.png class="hm-emoji">`;
      let el = div.children[0];
      if (this.textCursor) {
        // 将表情图片插入到失去焦点前光标位置
        this.textCursor.insertNode(el);
        // 通过将新加dom加入range文本块后折叠到最后的方式，改变光标位置到新增表情后面 否则插入顺序会变反
        this.textCursor.selectNode(el);
        this.textCursor.collapse();
      } else {
        // 首次直接添加表情到编辑器最后面
        this.$refs.editor.appendChild(el);
      }
    },
    // 将图片插入编辑器dom树中
    addImgToDom(src) {
      let img = document.createElement('img');
      img.src = src;
      if (this.textCursor) {
        this.textCursor.insertNode(img);
        this.textCursor.selectNode(img);
        this.textCursor.collapse();
      } else {
        this.$refs.editor.appendChild(img);
      }
    },
    // 插入图片
    insertImage() {
      this.emojiSelectorShow = false;
      this.uploadImage(9, true);
    },
    moveEventListener() {
      if (this.listener) {
        document.body.moveEventListener('focusout', () => {
          window.scrollTo(0, 0);
        });
      }
    },
    // 获取编辑框中所有图片（不含表情）
    getEditorImg() {
      let imgTagList = Array.from(this.$refs.editor.getElementsByTagName('img'));
      let imgList = [];
      imgTagList.forEach((item, index) => {
        if (item.className != 'hm-emoji') {
          imgList.push(item.src);
        }
      });
      return imgList;
    },
    // 获取编辑框中所有的文本（包括表情）
    getEditorText() {
      let el = document.createElement('div');
      el.innerHTML = this.editorContent;
      let imgTagList = Array.from(el.getElementsByTagName('img'));
      let removeImgList = [];
      imgTagList.forEach((item, index) => {
        if (item.className != 'hm-emoji') {
          removeImgList.push(item);
        }
      });
      removeImgList.forEach((item) => item.remove());
      return el.innerHTML;
    },
    async submit() {
      this.getUserInfo();
      let prohibition = this.userInfo.prohibition;
      if (prohibition.state_type == 1) {
        let warnMsg = `您的论坛账号已被封禁\n 封禁时间：${
          prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
        }\n如有疑问请联系客服`;
        Dialog.alert({
          title: '温馨提示',
          message: warnMsg,
        }).then(() => {
          this.$emit('closeIssueTopicField');
        });
        return;
      }
      if (prohibition.state_type == 3) {
        let warnMsg = `您已被禁言\n 禁言时间：${
          prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
        }`;
        Dialog.alert({
          title: '温馨提示',
          message: warnMsg,
        }).then(() => {});
        return;
      }
      this.editorContent = this.$refs.editor && this.$refs.editor.innerHTML;
      if (this.upLoadImgFlag) {
        this.$toast('图片正在上传中');
        return;
      }
      if (!this.topicTitle) {
        this.$toast('请输入标题');
        return;
      }
      if (!this.editorContent) {
        this.$toast('请输入内容');
        return;
      }
      if (!this.selectedCircleId) {
        this.$toast('请选择游戏圈');
        return;
      }
      // 将编辑器中的图片收集供展示用(3张图片)
      let imgList = this.getEditorImg().slice(0, 3);
      let textContent = this.getEditorText().slice(0, 1001);
      try {
        const r = await addTopic({
          title: this.topicTitle,
          content: this.editorContent,
          content_split: JSON.stringify({ imgList, textContent }),
          game_circle_id: this.selectedCircleId,
        });
        Toast.success('发布成功');
        this.emojiSelectorShow = false;
        this.$emit('closeIssueTopicField');
        if (this.circleId) {
          this.$bus.$emit('getTopicList');
        }
      } catch (error) {
        Toast.fail(error.message);
      }
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';

@keyframes slide-bottom-in {
  0% {
    top: 100%;
  }
  100% {
    top: 44px;
  }
}
.issue {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 200;
  background: #fff;
  animation: slide-bottom-in 0.5s linear;
  overflow: hidden;
  .editor {
    position: relative;
    height: calc(100vh - 170px);
    outline: none;
    padding: 20px 15px 15px 15px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-line;
    img {
      width: 95%;
      display: block;
      margin: 10px auto;
    }
  }
  .footer {
    position: absolute;
    bottom: 15px;
    left: 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 10px;
    display: flex;
    background: #ffffff;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    .submit {
      width: 70px;
      height: 33px;
      background: rgba(69, 175, 243, 1);
      border-radius: 16px;
      color: #fff;
      font-size: 10px;
    }
    .emoji {
      position: absolute;
      bottom: -200px;
      left: 0;
      &.active {
        bottom: 44px;
      }
    }
    .operate {
      display: flex;
      align-items: center;
      > img {
        width: 20px;
        height: 20px;
        display: inline-block;
        margin-right: 18px;
      }
    }
  }
}
</style>
